import { mapState } from 'vuex';
const DEFAULT_STEPS = [
	{
		name: 'vallalkozas',
		text: 'Adatok megadása',
		pending: false,
		current: true,
		done: false,
		editUrl: '#/vallalkozas#top'
	},
	{
		name: 'fajlfeltoltes',
		text: 'Cégdokumentum feltöltés',
		pending: false,
		current: false,
		done: false,
		editUrl: '#/fajlfeltoltes#top'
	},
	{
		name: 'osszegzo',
		text: 'Ellenőrzés',
		pending: false,
		current: false,
		done: false,
		editUrl: '#/osszegzo#top'
	}
];
export default {
	computed: {
		...mapState('eSignature', ['visitedPages', 'currentPage']),
		dots() {
			const indexOfCurrentPage = this.visitedPages.indexOf(this.currentPage);
			return JSON.parse(JSON.stringify(DEFAULT_STEPS)).map((step, index) => {
				const isAfterCurrentPage = index > indexOfCurrentPage;
				step.current = step.name == this.currentPage;
				step.editUrl = this.visitedPages.includes(step.name) && !isAfterCurrentPage ? step.editUrl : null;
				step.done = !step.current && indexOfCurrentPage >= index;
				return step;
			});
		}
	},
	render() {
		return this.$scopedSlots.default({
			steps: this.dots
		});
	}
};
